import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import { getCategory, createSubCategory, updateSubCategory } from "../../../Utility/Api";
import { WarehouseContext } from '../../../Utility/UserContext';





export const EditSubCategory = ({ showModal, setShowModal, fetchSubCategory, selectedSubCategory, fetchdata, AddorEdit, setCurrentPage }) => {

    const { showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);

    const [formData, setFormData] = useState({
        subcategory: '', category_id: '', status: '',
        shop_id: shopItem?.shop_id || "0", created_by: UserItem?.user_id || "0",
    });
    const [Category, setCategory] = useState([]);
    const [errors, setErrors] = useState({})
      const [searchTerm, setSearchTerm] = useState('');
    

    useEffect(() => {
        fetchCategory();
        if (selectedSubCategory) {
            setFormData({
                subcategory: selectedSubCategory?.subcategory_name || '',
                category_id: selectedSubCategory?.category_id || '',
                status: selectedSubCategory?.status?.toString() || '',
            });
        } else {
            setFormData({ subcategory: '', category_id: '', status: '' });
        }
    }, [selectedSubCategory]);
    useEffect(() => {
        if (formData.category_id && !formData.category_name && Category.length > 0) {
          const matchedCategory = Category.find(cat => cat.id === formData.category_id);
          if (matchedCategory) {
            setFormData(prev => ({
              ...prev,
              category_name: matchedCategory.Categories
            }));
          }
        }
      }, [formData.category_id, formData.category_name, Category]);
      

    const fetchCategory = async () => {
        try {
            const response = await getCategory();
            if (response.data.data) {
                setCategory(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };

    const handleSubmit = async (e) => {
        showLoader()
        e.preventDefault();
        const validationErrors = {};

        if (!formData.category_id) {
            validationErrors.category_id = "category title is required.";
        }
        if (!formData.subcategory) {
            validationErrors.subcategory = "subcategory title is required.";
        }


        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            hideLoader();

            return;
        }


        const payload = {
            subcategories: formData.subcategory,
            cat_id: formData.category_id,
            created_by: UserItem?.user_id || "0",
            status: formData.status,
            shop_id: shopItem?.shop_id || "0",
        };

        console.log('Payload being sent:', payload);
        try {
            if (AddorEdit) {
                await createSubCategory(payload);
                hideLoader()
                toast.success('Sub Category Added successfully');
                fetchSubCategory();


            } else {
                await updateSubCategory(selectedSubCategory?.subcategory_id, payload);
                hideLoader()
                toast.success('Sub Category Updated successfully');
                fetchSubCategory();

            }
            setCurrentPage(1)
            handleCancel();
            fetchdata();
        } catch (error) {
            console.error('Error Category data:', error);
            toast.error(error?.response?.data?.message);
            hideLoader();
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    const handleCancel = () => {
        setShowModal(false);
        setFormData({
            subcategory: '', category_id: ''
        });
    };



    return (
        <>
            {showModal && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>{selectedSubCategory ? 'Edit Sub Category' : 'Add   SubCategory'}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() => handleCancel()}
                                ></button>
                            </div>
                            <div className="modal-body" style={{ fontFamily: "poppins" }}>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group mb-3">
                                        <label>SubCategory</label>
                                        <div className="col-12">
                                            <input
                                                type="text"
                                                name="subcategory"
                                                value={formData.subcategory}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                            {errors.subcategory && (
                                                <small className="text-danger">{errors.subcategory}</small>
                                            )}
                                        </div>
                                    </div>
                                    {/* <div className="form-group mb-3">
                                        <label>Category</label>
                                        <div className="col-12">
                                            <select
                                                name="category_id"
                                                value={formData.category_id}
                                                onChange={handleChange}
                                                className="form-control"

                                            >
                                                <option value="">Select Category</option>
                                                {Category
                                                    ?.filter((f) => f.status != "1")
                                                    ?.map((cat) => (
                                                        <option key={cat.id} value={cat.id}>
                                                            {cat.Categories}
                                                        </option>
                                                    ))}
                                            </select>
                                            {errors.category_id && (
                                                <small className="text-danger">{errors.category_id}</small>
                                            )}
                                        </div>
                                    </div> */}
                                    <div className="dropdown w-100 mb-3">
  <label className="form-label fw-semibold mb-2">Category</label>
  
  {/* Button to open the dropdown */}
  <button
    className="btn btn-outline-secondary fw-semibold w-100 text-start"
    type="button"
    id="categoryDropdown"
    data-bs-toggle="dropdown"
    aria-expanded="false"
    name="category_id"
    value={formData.category_id}
    onChange={handleChange}
    style={{
      height: "50px",
      borderRadius: "6px",
      padding: "10px 12px",
    }}
  >
    {formData.category_name || 'Select Category'}
  </button>

  {/* Dropdown menu */}
  <ul
    className="dropdown-menu w-100 p-2 shadow-sm"
    aria-labelledby="categoryDropdown"
    style={{
      maxHeight: "50vh",
      overflowY: "auto",
      minWidth: "100%",
      zIndex: 1050,
    }}
  >
    {/* Search input */}
    <li>
      <input
        type="text"
        placeholder="Search category..."
        className="form-control mb-2"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </li>

    {/* Map categories */}
    {Category
      ?.filter((f) => f.status !== "1")
      ?.filter((cat) =>
        cat.Categories.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .map((cat) => (
        <li key={cat.id}>
          <button
            type="button"
            className="dropdown-item"
            onClick={() => {
              // Set selected category to formData
              setFormData((prev) => ({
                ...prev,
                category_id: cat.id,
                category_name: cat.Categories,
              }));
              setSearchTerm(""); // Optionally clear search term
            }}
          >
            {cat.Categories}
          </button>
        </li>
      ))}

    {/* Show message if no matching categories */}
    {Category?.filter((cat) =>
      cat.Categories.toLowerCase().includes(searchTerm.toLowerCase())
    ).length === 0 && (
      <li className="text-center text-muted py-2">
        No matching category
      </li>
    )}
  </ul>
</div>


                                    {/* <div className="form-group mb-3">
                                        <label>Status</label>
                                        <select
                                            name="status"
                                            value={formData.status}
                                            onChange={handleChange}
                                            className="form-control"
                                            required
                                        >
                                            <option value="" disabled>Select Status</option>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div> */}
                                    <button type="submit" className="btn btn-success float-end">
                                        {selectedSubCategory ? 'Update Sub Category' : 'Add Sub Category'}
                                    </button>
                                    &nbsp;&nbsp;
                                    <button
                                        type="button"
                                        className="btn btn-secondary ml-2 float-end me-1"
                                        onClick={() => handleCancel()}
                                    >
                                        Cancel
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}</>

    )
}
